import React, { useEffect, useState } from "react";
import scrollUp from '../../Constant/Icons/scrollDown.svg'; // Or switch to a proper upward icon

const GoToTopButton = () => {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const checkScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      // console.log(window.pageYOffset , document.documentElement.scrollTop , document.body.scrollTop , 0);
      
      setShowButton(scrollTop > 300);
    };

    checkScroll();
    window.addEventListener("scroll", checkScroll);
    window.addEventListener("resize", checkScroll);

    return () => {
      window.removeEventListener("scroll", checkScroll);
      window.removeEventListener("resize", checkScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!showButton) return null;

  return (
    <div style={{ position: "fixed", right: "20px", bottom: "20px" }}>
      <img style={buttonStyle} onClick={scrollToTop} src={scrollUp} alt="Scroll to top" />
    </div>
  );
};

const buttonStyle = {
  padding: "10px 20px",
  width: "60px",
  transform: "rotate(0deg)", // Make sure it points up!
  zIndex: 1000000,
  borderRadius: "50%",
  backgroundColor: 'blue',
  color: "#fff",
  border: "none",
  cursor: "pointer",
};

export default GoToTopButton;
